import React from 'react';
import { TaskForm } from '../../components/Tasks';

const TaskEdit = () => {
  return <TaskForm isEdit={true} />;
};

export default TaskEdit;


